/**
 * @fileoverview gRPC-Web generated client stub for itp
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: itp_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var pathway_pb = require('./pathway_pb.js')

var auth_token_pb = require('./auth/token_pb.js')

var leaderboard_pb = require('./leaderboard_pb.js')

var podcast_pb = require('./podcast_pb.js')

var video_pb = require('./video_pb.js')

var user_pb = require('./user_pb.js')

var played_pb = require('./played_pb.js')
const proto = {};
proto.itp = require('./itp_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.itp.ITPServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.itp.ITPServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.PingRequest,
 *   !proto.itp.PingResponse>}
 */
const methodDescriptor_ITPService_Ping = new grpc.web.MethodDescriptor(
  '/itp.ITPService/Ping',
  grpc.web.MethodType.UNARY,
  proto.itp.PingRequest,
  proto.itp.PingResponse,
  /**
   * @param {!proto.itp.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.PingResponse.deserializeBinary
);


/**
 * @param {!proto.itp.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/Ping',
      request,
      metadata || {},
      methodDescriptor_ITPService_Ping,
      callback);
};


/**
 * @param {!proto.itp.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.PingResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/Ping',
      request,
      metadata || {},
      methodDescriptor_ITPService_Ping);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetTodayLeaderboardRequest,
 *   !proto.itp.GetTodayLeaderboardResponse>}
 */
const methodDescriptor_ITPService_GetTodayLeaderboard = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetTodayLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.itp.GetTodayLeaderboardRequest,
  proto.itp.GetTodayLeaderboardResponse,
  /**
   * @param {!proto.itp.GetTodayLeaderboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetTodayLeaderboardResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetTodayLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetTodayLeaderboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetTodayLeaderboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getTodayLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetTodayLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetTodayLeaderboard,
      callback);
};


/**
 * @param {!proto.itp.GetTodayLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetTodayLeaderboardResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getTodayLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetTodayLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetTodayLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetSchoolLeaderboardRequest,
 *   !proto.itp.GetSchoolLeaderboardResponse>}
 */
const methodDescriptor_ITPService_GetSchoolLeaderboard = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetSchoolLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.itp.GetSchoolLeaderboardRequest,
  proto.itp.GetSchoolLeaderboardResponse,
  /**
   * @param {!proto.itp.GetSchoolLeaderboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetSchoolLeaderboardResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetSchoolLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetSchoolLeaderboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetSchoolLeaderboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getSchoolLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetSchoolLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetSchoolLeaderboard,
      callback);
};


/**
 * @param {!proto.itp.GetSchoolLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetSchoolLeaderboardResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getSchoolLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetSchoolLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetSchoolLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetStudentLeaderboardRequest,
 *   !proto.itp.GetStudentLeaderboardResponse>}
 */
const methodDescriptor_ITPService_GetStudentLeaderboard = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetStudentLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.itp.GetStudentLeaderboardRequest,
  proto.itp.GetStudentLeaderboardResponse,
  /**
   * @param {!proto.itp.GetStudentLeaderboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetStudentLeaderboardResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetStudentLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetStudentLeaderboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetStudentLeaderboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getStudentLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetStudentLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetStudentLeaderboard,
      callback);
};


/**
 * @param {!proto.itp.GetStudentLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetStudentLeaderboardResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getStudentLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetStudentLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetStudentLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetSchoolStudentLeaderboardRequest,
 *   !proto.itp.GetSchoolStudentLeaderboardResponse>}
 */
const methodDescriptor_ITPService_GetSchoolStudentLeaderboard = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetSchoolStudentLeaderboard',
  grpc.web.MethodType.UNARY,
  proto.itp.GetSchoolStudentLeaderboardRequest,
  proto.itp.GetSchoolStudentLeaderboardResponse,
  /**
   * @param {!proto.itp.GetSchoolStudentLeaderboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetSchoolStudentLeaderboardResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetSchoolStudentLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetSchoolStudentLeaderboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetSchoolStudentLeaderboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getSchoolStudentLeaderboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetSchoolStudentLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetSchoolStudentLeaderboard,
      callback);
};


/**
 * @param {!proto.itp.GetSchoolStudentLeaderboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetSchoolStudentLeaderboardResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getSchoolStudentLeaderboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetSchoolStudentLeaderboard',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetSchoolStudentLeaderboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.WatchedVideoRequest,
 *   !proto.itp.WatchedVideoResponse>}
 */
const methodDescriptor_ITPService_WatchedVideo = new grpc.web.MethodDescriptor(
  '/itp.ITPService/WatchedVideo',
  grpc.web.MethodType.UNARY,
  proto.itp.WatchedVideoRequest,
  proto.itp.WatchedVideoResponse,
  /**
   * @param {!proto.itp.WatchedVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.WatchedVideoResponse.deserializeBinary
);


/**
 * @param {!proto.itp.WatchedVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.WatchedVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.WatchedVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.watchedVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/WatchedVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_WatchedVideo,
      callback);
};


/**
 * @param {!proto.itp.WatchedVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.WatchedVideoResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.watchedVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/WatchedVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_WatchedVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListenedPodcastRequest,
 *   !proto.itp.ListenedPodcastResponse>}
 */
const methodDescriptor_ITPService_ListenedPodcast = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListenedPodcast',
  grpc.web.MethodType.UNARY,
  proto.itp.ListenedPodcastRequest,
  proto.itp.ListenedPodcastResponse,
  /**
   * @param {!proto.itp.ListenedPodcastRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListenedPodcastResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListenedPodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListenedPodcastResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListenedPodcastResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listenedPodcast =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListenedPodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListenedPodcast,
      callback);
};


/**
 * @param {!proto.itp.ListenedPodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListenedPodcastResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listenedPodcast =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListenedPodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListenedPodcast);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetUserScoreRequest,
 *   !proto.itp.GetUserScoreResponse>}
 */
const methodDescriptor_ITPService_GetUserScore = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetUserScore',
  grpc.web.MethodType.UNARY,
  proto.itp.GetUserScoreRequest,
  proto.itp.GetUserScoreResponse,
  /**
   * @param {!proto.itp.GetUserScoreRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetUserScoreResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetUserScoreRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetUserScoreResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetUserScoreResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getUserScore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetUserScore',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUserScore,
      callback);
};


/**
 * @param {!proto.itp.GetUserScoreRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetUserScoreResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getUserScore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetUserScore',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUserScore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListVideosForPathwayRequest,
 *   !proto.itp.ListVideosForPathwayResponse>}
 */
const methodDescriptor_ITPService_ListVideosForPathway = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListVideosForPathway',
  grpc.web.MethodType.UNARY,
  proto.itp.ListVideosForPathwayRequest,
  proto.itp.ListVideosForPathwayResponse,
  /**
   * @param {!proto.itp.ListVideosForPathwayRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListVideosForPathwayResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListVideosForPathwayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListVideosForPathwayResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListVideosForPathwayResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listVideosForPathway =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListVideosForPathway',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListVideosForPathway,
      callback);
};


/**
 * @param {!proto.itp.ListVideosForPathwayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListVideosForPathwayResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listVideosForPathway =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListVideosForPathway',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListVideosForPathway);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListPodcastsForPathwayRequest,
 *   !proto.itp.ListPodcastsForPathwayResponse>}
 */
const methodDescriptor_ITPService_ListPodcastsForPathway = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListPodcastsForPathway',
  grpc.web.MethodType.UNARY,
  proto.itp.ListPodcastsForPathwayRequest,
  proto.itp.ListPodcastsForPathwayResponse,
  /**
   * @param {!proto.itp.ListPodcastsForPathwayRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListPodcastsForPathwayResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListPodcastsForPathwayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListPodcastsForPathwayResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListPodcastsForPathwayResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listPodcastsForPathway =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListPodcastsForPathway',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListPodcastsForPathway,
      callback);
};


/**
 * @param {!proto.itp.ListPodcastsForPathwayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListPodcastsForPathwayResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listPodcastsForPathway =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListPodcastsForPathway',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListPodcastsForPathway);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.UpdateUserRequest,
 *   !proto.itp.UpdateUserResponse>}
 */
const methodDescriptor_ITPService_UpdateUser = new grpc.web.MethodDescriptor(
  '/itp.ITPService/UpdateUser',
  grpc.web.MethodType.UNARY,
  proto.itp.UpdateUserRequest,
  proto.itp.UpdateUserResponse,
  /**
   * @param {!proto.itp.UpdateUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.UpdateUserResponse.deserializeBinary
);


/**
 * @param {!proto.itp.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.UpdateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.UpdateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_ITPService_UpdateUser,
      callback);
};


/**
 * @param {!proto.itp.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.UpdateUserResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_ITPService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetUserRequest,
 *   !proto.itp.GetUserResponse>}
 */
const methodDescriptor_ITPService_GetUser = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetUser',
  grpc.web.MethodType.UNARY,
  proto.itp.GetUserRequest,
  proto.itp.GetUserResponse,
  /**
   * @param {!proto.itp.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetUser',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUser,
      callback);
};


/**
 * @param {!proto.itp.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetUser',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListPathwaysRequest,
 *   !proto.itp.ListPathwaysResponse>}
 */
const methodDescriptor_ITPService_ListPathways = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListPathways',
  grpc.web.MethodType.UNARY,
  proto.itp.ListPathwaysRequest,
  proto.itp.ListPathwaysResponse,
  /**
   * @param {!proto.itp.ListPathwaysRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListPathwaysResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListPathwaysRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListPathwaysResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListPathwaysResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listPathways =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListPathways',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListPathways,
      callback);
};


/**
 * @param {!proto.itp.ListPathwaysRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListPathwaysResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listPathways =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListPathways',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListPathways);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.GetUserPlayLogRequest,
 *   !proto.itp.GetUserPlayLogResponse>}
 */
const methodDescriptor_ITPService_GetUserPlayLog = new grpc.web.MethodDescriptor(
  '/itp.ITPService/GetUserPlayLog',
  grpc.web.MethodType.UNARY,
  proto.itp.GetUserPlayLogRequest,
  proto.itp.GetUserPlayLogResponse,
  /**
   * @param {!proto.itp.GetUserPlayLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.GetUserPlayLogResponse.deserializeBinary
);


/**
 * @param {!proto.itp.GetUserPlayLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.GetUserPlayLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.GetUserPlayLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.getUserPlayLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/GetUserPlayLog',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUserPlayLog,
      callback);
};


/**
 * @param {!proto.itp.GetUserPlayLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.GetUserPlayLogResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.getUserPlayLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/GetUserPlayLog',
      request,
      metadata || {},
      methodDescriptor_ITPService_GetUserPlayLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.CreateVideoRequest,
 *   !proto.itp.CreateVideoResponse>}
 */
const methodDescriptor_ITPService_CreateVideo = new grpc.web.MethodDescriptor(
  '/itp.ITPService/CreateVideo',
  grpc.web.MethodType.UNARY,
  proto.itp.CreateVideoRequest,
  proto.itp.CreateVideoResponse,
  /**
   * @param {!proto.itp.CreateVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.CreateVideoResponse.deserializeBinary
);


/**
 * @param {!proto.itp.CreateVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.CreateVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.CreateVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.createVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/CreateVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_CreateVideo,
      callback);
};


/**
 * @param {!proto.itp.CreateVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.CreateVideoResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.createVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/CreateVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_CreateVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.CreatePodcastRequest,
 *   !proto.itp.CreatePodcastResponse>}
 */
const methodDescriptor_ITPService_CreatePodcast = new grpc.web.MethodDescriptor(
  '/itp.ITPService/CreatePodcast',
  grpc.web.MethodType.UNARY,
  proto.itp.CreatePodcastRequest,
  proto.itp.CreatePodcastResponse,
  /**
   * @param {!proto.itp.CreatePodcastRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.CreatePodcastResponse.deserializeBinary
);


/**
 * @param {!proto.itp.CreatePodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.CreatePodcastResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.CreatePodcastResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.createPodcast =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/CreatePodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_CreatePodcast,
      callback);
};


/**
 * @param {!proto.itp.CreatePodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.CreatePodcastResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.createPodcast =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/CreatePodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_CreatePodcast);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.DeleteVideoRequest,
 *   !proto.itp.DeleteVideoResponse>}
 */
const methodDescriptor_ITPService_DeleteVideo = new grpc.web.MethodDescriptor(
  '/itp.ITPService/DeleteVideo',
  grpc.web.MethodType.UNARY,
  proto.itp.DeleteVideoRequest,
  proto.itp.DeleteVideoResponse,
  /**
   * @param {!proto.itp.DeleteVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.DeleteVideoResponse.deserializeBinary
);


/**
 * @param {!proto.itp.DeleteVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.DeleteVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.DeleteVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.deleteVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/DeleteVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeleteVideo,
      callback);
};


/**
 * @param {!proto.itp.DeleteVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.DeleteVideoResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.deleteVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/DeleteVideo',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeleteVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.DeletePodcastRequest,
 *   !proto.itp.DeletePodcastResponse>}
 */
const methodDescriptor_ITPService_DeletePodcast = new grpc.web.MethodDescriptor(
  '/itp.ITPService/DeletePodcast',
  grpc.web.MethodType.UNARY,
  proto.itp.DeletePodcastRequest,
  proto.itp.DeletePodcastResponse,
  /**
   * @param {!proto.itp.DeletePodcastRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.DeletePodcastResponse.deserializeBinary
);


/**
 * @param {!proto.itp.DeletePodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.DeletePodcastResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.DeletePodcastResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.deletePodcast =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/DeletePodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeletePodcast,
      callback);
};


/**
 * @param {!proto.itp.DeletePodcastRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.DeletePodcastResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.deletePodcast =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/DeletePodcast',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeletePodcast);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListAllVideosRequest,
 *   !proto.itp.ListAllVideosResponse>}
 */
const methodDescriptor_ITPService_ListAllVideos = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListAllVideos',
  grpc.web.MethodType.UNARY,
  proto.itp.ListAllVideosRequest,
  proto.itp.ListAllVideosResponse,
  /**
   * @param {!proto.itp.ListAllVideosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListAllVideosResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListAllVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListAllVideosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListAllVideosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listAllVideos =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListAllVideos',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllVideos,
      callback);
};


/**
 * @param {!proto.itp.ListAllVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListAllVideosResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listAllVideos =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListAllVideos',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllVideos);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListAllPodcastsRequest,
 *   !proto.itp.ListAllPodcastsResponse>}
 */
const methodDescriptor_ITPService_ListAllPodcasts = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListAllPodcasts',
  grpc.web.MethodType.UNARY,
  proto.itp.ListAllPodcastsRequest,
  proto.itp.ListAllPodcastsResponse,
  /**
   * @param {!proto.itp.ListAllPodcastsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListAllPodcastsResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListAllPodcastsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListAllPodcastsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListAllPodcastsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listAllPodcasts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListAllPodcasts',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllPodcasts,
      callback);
};


/**
 * @param {!proto.itp.ListAllPodcastsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListAllPodcastsResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listAllPodcasts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListAllPodcasts',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllPodcasts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.DeleteAccountRequest,
 *   !proto.itp.DeleteAccountResponse>}
 */
const methodDescriptor_ITPService_DeleteAccount = new grpc.web.MethodDescriptor(
  '/itp.ITPService/DeleteAccount',
  grpc.web.MethodType.UNARY,
  proto.itp.DeleteAccountRequest,
  proto.itp.DeleteAccountResponse,
  /**
   * @param {!proto.itp.DeleteAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.DeleteAccountResponse.deserializeBinary
);


/**
 * @param {!proto.itp.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.DeleteAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.DeleteAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.deleteAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/DeleteAccount',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeleteAccount,
      callback);
};


/**
 * @param {!proto.itp.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.DeleteAccountResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.deleteAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/DeleteAccount',
      request,
      metadata || {},
      methodDescriptor_ITPService_DeleteAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListAllUsersRequest,
 *   !proto.itp.ListAllUsersResponse>}
 */
const methodDescriptor_ITPService_ListAllUsers = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListAllUsers',
  grpc.web.MethodType.UNARY,
  proto.itp.ListAllUsersRequest,
  proto.itp.ListAllUsersResponse,
  /**
   * @param {!proto.itp.ListAllUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListAllUsersResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListAllUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListAllUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListAllUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listAllUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListAllUsers',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllUsers,
      callback);
};


/**
 * @param {!proto.itp.ListAllUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListAllUsersResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listAllUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListAllUsers',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.ListAllUserScoresRequest,
 *   !proto.itp.ListAllUserScoresResponse>}
 */
const methodDescriptor_ITPService_ListAllUserScores = new grpc.web.MethodDescriptor(
  '/itp.ITPService/ListAllUserScores',
  grpc.web.MethodType.UNARY,
  proto.itp.ListAllUserScoresRequest,
  proto.itp.ListAllUserScoresResponse,
  /**
   * @param {!proto.itp.ListAllUserScoresRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.ListAllUserScoresResponse.deserializeBinary
);


/**
 * @param {!proto.itp.ListAllUserScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.ListAllUserScoresResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.ListAllUserScoresResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.listAllUserScores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/ListAllUserScores',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllUserScores,
      callback);
};


/**
 * @param {!proto.itp.ListAllUserScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.ListAllUserScoresResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.listAllUserScores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/ListAllUserScores',
      request,
      metadata || {},
      methodDescriptor_ITPService_ListAllUserScores);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.itp.AdminGetUserPlayLogRequest,
 *   !proto.itp.AdminGetUserPlayLogResponse>}
 */
const methodDescriptor_ITPService_AdminGetUserPlayLog = new grpc.web.MethodDescriptor(
  '/itp.ITPService/AdminGetUserPlayLog',
  grpc.web.MethodType.UNARY,
  proto.itp.AdminGetUserPlayLogRequest,
  proto.itp.AdminGetUserPlayLogResponse,
  /**
   * @param {!proto.itp.AdminGetUserPlayLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.itp.AdminGetUserPlayLogResponse.deserializeBinary
);


/**
 * @param {!proto.itp.AdminGetUserPlayLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.itp.AdminGetUserPlayLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.itp.AdminGetUserPlayLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.itp.ITPServiceClient.prototype.adminGetUserPlayLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/itp.ITPService/AdminGetUserPlayLog',
      request,
      metadata || {},
      methodDescriptor_ITPService_AdminGetUserPlayLog,
      callback);
};


/**
 * @param {!proto.itp.AdminGetUserPlayLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.itp.AdminGetUserPlayLogResponse>}
 *     Promise that resolves to the response
 */
proto.itp.ITPServicePromiseClient.prototype.adminGetUserPlayLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/itp.ITPService/AdminGetUserPlayLog',
      request,
      metadata || {},
      methodDescriptor_ITPService_AdminGetUserPlayLog);
};


module.exports = proto.itp;

